
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import Button from '../../../components/base/Button';

export default function LongevityPage() {
  const handleConsultationClick = () => {
    window.REACT_APP_NAVIGATE('/consultation');
  };

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-[#8A4F8A] to-[#C8A2C8] text-white overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://public.readdy.ai/ai/img_res/bac77560069d2454d9011b3520639d4e.jpg)'
          }}
        ></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-6">
              Longevity & <span className="text-[#F0F0F0]">Life Extension</span>
            </h1>
            <p className="text-xl mb-8 text-[#F0F0F0]">
              Advanced anti-aging protocols and life extension therapies designed to optimize cellular health, enhance vitality, and promote healthy aging.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button size="lg" className="bg-white text-[#8A4F8A] hover:bg-[#F0F0F0]" disabled>
                <i className="ri-time-line mr-2"></i>
                Coming Soon
              </Button>
              <Button size="lg" variant="secondary" className="border-white text-white hover:bg-white hover:text-[#8A4F8A]" onClick={handleConsultationClick}>
                <i className="ri-notification-line mr-2"></i>
                Get Notified
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Coming Soon Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-gradient-to-b from-[#F0F0F0] to-white rounded-xl shadow-lg p-12">
            <div className="w-24 h-24 bg-[#8A4F8A] rounded-full flex items-center justify-center mx-auto mb-8">
              <i className="ri-time-line text-4xl text-white"></i>
            </div>
            
            <h2 className="text-4xl font-bold text-black mb-6">
              Revolutionary <span className="text-[#8A4F8A]">Longevity Treatments</span>
            </h2>
            
            <p className="text-xl text-[#B0B0B0] mb-8 max-w-2xl mx-auto">
              We're developing cutting-edge longevity and life extension protocols that will transform how we approach aging and cellular health. Our comprehensive program will include advanced therapies, personalized protocols, and innovative treatments.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
              <div className="text-center">
                <div className="w-16 h-16 bg-[#8A4F8A]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-dna-line text-2xl text-[#8A4F8A]"></i>
                </div>
                <h3 className="text-lg font-bold text-black mb-2">Cellular Optimization</h3>
                <p className="text-[#B0B0B0] text-sm">Advanced cellular repair and regeneration protocols</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-[#8A4F8A]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-heart-pulse-line text-2xl text-[#8A4F8A]"></i>
                </div>
                <h3 className="text-lg font-bold text-black mb-2">Vitality Enhancement</h3>
                <p className="text-[#B0B0B0] text-sm">Comprehensive programs to boost energy and wellness</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-[#8A4F8A]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-line text-2xl text-[#8A4F8A]"></i>
                </div>
                <h3 className="text-lg font-bold text-black mb-2">Preventive Medicine</h3>
                <p className="text-[#B0B0B0] text-sm">Proactive approaches to healthy aging and disease prevention</p>
              </div>
            </div>

            <div className="bg-white rounded-lg p-6 mb-8">
              <h3 className="text-xl font-bold text-black mb-4">Be the First to Know</h3>
              <p className="text-[#B0B0B0] mb-6">
                Join our exclusive waitlist to receive updates about our longevity program launch and be among the first to access these revolutionary treatments.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button size="lg" onClick={handleConsultationClick}>
                  <i className="ri-mail-line mr-2"></i>
                  Join Waitlist
                </Button>
                <Button size="lg" variant="secondary" onClick={() => window.open('tel:202-269-6600', '_self')}>
                  <i className="ri-phone-line mr-2"></i>
                  Call for Updates
                </Button>
              </div>
            </div>

            <p className="text-sm text-[#B0B0B0]">
              Expected launch: 2024. Stay tuned for more information about our comprehensive longevity and life extension program.
            </p>
          </div>
        </div>
      </section>

      {/* Current Services Section */}
      <section className="py-16 bg-gradient-to-b from-[#F0F0F0] to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-black mb-4">
              Explore Our <span className="text-[#8A4F8A]">Current Services</span>
            </h2>
            <p className="text-xl text-[#B0B0B0] max-w-3xl mx-auto">
              While we prepare our longevity program, discover our existing wellness services that support healthy aging
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              {
                title: 'Peptide Therapy',
                description: 'Cellular regeneration and anti-aging peptides',
                icon: 'ri-dna-line',
                link: '/services/peptide-therapy'
              },
              {
                title: 'IV Therapy',
                description: 'NAD+ and anti-aging infusions',
                icon: 'ri-drop-line',
                link: '/services/iv-therapy'
              },
              {
                title: 'Sexual Wellness',
                description: 'Hormone optimization and vitality',
                icon: 'ri-heart-pulse-line',
                link: '/services/sexual-wellness'
              },
              {
                title: 'Mental Health',
                description: 'Cognitive enhancement and wellness',
                icon: 'ri-brain-line',
                link: '/services/mental-health'
              }
            ].map((service, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-6 text-center hover:shadow-xl transition-shadow duration-300">
                <div className="w-12 h-12 bg-[#8A4F8A] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${service.icon} text-xl text-white`}></i>
                </div>
                <h3 className="text-lg font-bold text-black mb-3">{service.title}</h3>
                <p className="text-[#B0B0B0] text-sm mb-4">{service.description}</p>
                <Button size="sm" className="w-full" onClick={() => window.REACT_APP_NAVIGATE(service.link)}>
                  Learn More
                </Button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
